import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Logo from './Logo';
import NotificacoesAdmin from './NotificacoesAdmin';
import { 
  LayoutDashboard, 
  Store, 
  Package, 
  ShoppingCart, 
  DollarSign,
  LogOut,
  Menu,
  X,
  CreditCard,
  Warehouse,
  ShoppingBag,
  Users,
  MessageSquare,
  Settings,
  FileText,
  TrendingUp,
  ChefHat,
  Truck,
  Ticket,
  UserCircle,
  FolderTree,
  PlusCircle
} from 'lucide-react';
import './Layout.css';

const Layout = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  const menuItems = [
    { path: '/admin/dashboard', icon: LayoutDashboard, label: 'Dashboard', section: 'principal' },
    { path: '/admin/cardapio', icon: Package, label: 'Cardápio', section: 'principal' },
    { path: '/admin/categorias', icon: FolderTree, label: 'Categorias', section: 'principal' },
    { path: '/admin/adicionais', icon: PlusCircle, label: 'Adicionais', section: 'principal' },
    { path: '/admin/pedidos', icon: ShoppingCart, label: 'Pedidos', section: 'principal' },
    { path: '/admin/cozinha', icon: ChefHat, label: 'Cozinha', section: 'operacional' },
    { path: '/admin/entregas', icon: Truck, label: 'Entregas', section: 'operacional' },
    { path: '/admin/caixa', icon: CreditCard, label: 'Caixa (PDV)', section: 'operacional' },
    { path: '/admin/financeiro', icon: DollarSign, label: 'Financeiro', section: 'erp' },
    { path: '/admin/estoque', icon: Warehouse, label: 'Estoque', section: 'erp' },
    { path: '/admin/cupons', icon: Ticket, label: 'Cupons', section: 'marketing' },
    { path: '/admin/clientes', icon: UserCircle, label: 'Clientes', section: 'gestao' },
    { path: '/admin/funcionarios', icon: Users, label: 'Funcionários', section: 'gestao' },
    { path: '/admin/entregadores', icon: Truck, label: 'Entregadores', section: 'gestao' },
    { path: '/admin/mensageria', icon: MessageSquare, label: 'Mensageria', section: 'gestao' },
    { path: '/admin/configuracoes', icon: Settings, label: 'Configurações', section: 'gestao' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="layout">
      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <Logo size="small" />
          <button className="sidebar-close" onClick={() => setSidebarOpen(false)}>
            <X size={24} />
          </button>
        </div>
        
        <nav className="sidebar-nav">
          {menuItems.map((item, index) => {
            const Icon = item.icon;
            const showDivider = index > 0 && 
              (item.section === 'operacional' && menuItems[index - 1].section === 'principal') ||
              (item.section === 'erp' && menuItems[index - 1].section === 'operacional') ||
              (item.section === 'marketing' && menuItems[index - 1].section === 'erp') ||
              (item.section === 'gestao' && menuItems[index - 1].section === 'marketing');
            
            return (
              <React.Fragment key={item.path}>
                {showDivider && <div className="nav-divider" />}
                <Link
                  to={item.path}
                  className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
                  onClick={() => setSidebarOpen(false)}
                >
                  <Icon size={20} />
                  <span>{item.label}</span>
                </Link>
              </React.Fragment>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <p>{user?.nome}</p>
            <span className="user-type">{user?.tipo}</span>
          </div>
          <button onClick={logout} className="btn-logout">
            <LogOut size={20} />
            Sair
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="main-content">
        <header className="header">
          <button className="menu-toggle" onClick={() => setSidebarOpen(true)}>
            <Menu size={24} />
          </button>
          <h1>{menuItems.find(item => isActive(item.path))?.label || 'Dashboard'}</h1>
        </header>
        
        <main className="content">
          <Outlet />
        </main>
      </div>
      
      {/* ✅ Componente de notificações para admin */}
      <NotificacoesAdmin />
    </div>
  );
};

export default Layout;

